import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { hide, show } from '../actions/ActivityIndicatorAction';
import Analytics from './Analytics/Report';
import AssetDashboardNew from './AssetHealthApp/AssetDashboardNew';
import HelpModal from './Custom/HelpModal';
import HirarchyDashboard from './Hirarchy/Dashboard';
import PFCReportContainer from './PFCReport/PFCReport';
import NewSLDViewer from './SLD/NewSLDViewer';
import { constants } from '../shared/constants';
import PowerBI from '../components/Custom/PowerBI';
import { session } from '../Service/APIService';
import EmbedComponent from './OtherApps/SupersetReports';

const FaultDashboardContainer = React.lazy(() =>
  import('../containers/FaultApp/FaultDashboardContainer')
);
const Sidebar = React.lazy(() => import('./layout/Sidebar'));
const EnergyEfficiencyDashboardContainer = React.lazy(() =>
  import('../containers/EnergyEfficiencyApp/EnergyEfficiencyDashboardContainer')
);
const HelpboxContainer = React.lazy(() =>
  import('../containers/Helpbox/HelpboxContainer')
);
const NotFound = React.lazy(() => import('./layout/NotFound'));
const AssetDashboardContainer = React.lazy(() =>
  import('../containers/AssetHealthApp/AssetDashboardContainer')
);
const Unauthorize = React.lazy(() => import('./auth/Unauthorize'));
const Dashboard = React.lazy(() => import('./MonitoringApp/Dashboard'));

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      footerText: '',
      showHelp: false,
    };
  }

  componentDidMount() {
    if (!document.body.classList.contains('sidebar-hidden')) {
      document.body.classList.toggle('sidebar-hidden');
    }

    const defaultConfig = session.config();
    if (defaultConfig) {
      this.setState({ footerText: defaultConfig.footerText });
    }
  }

  render() {
    const clientId = session.client();
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <div>
          {this.props.routechecker.isCorrect && <Sidebar />}
          <button
            className="btn btn-warning help"
            title="help"
            onClick={() => this.setState({ showHelp: true })}
          >
            ?
          </button>
          <div>
            <Switch>
              <Route
                path="/home"
                name="FaultDashboard"
                component={FaultDashboardContainer}
              />
              <Route
                path="/faultdashboard"
                name="FaultDashboard"
                component={FaultDashboardContainer}
              />
              <Route
                path="/eedashboard"
                name="EnergyMonitoring"
                component={EnergyEfficiencyDashboardContainer}
              />
              <Route
                path="/eereportsnew"
                render={() => (
                  <Analytics appName={constants.core.APPS.ENERGY_EFFICIENCY} />
                )}
              />
              <Route
                path="/fareportsnew"
                render={() => <Analytics appName={constants.core.APPS.FAULT} />}
              />
              <Route
                path="/assetreportsnew"
                render={() => <Analytics appName={constants.core.APPS.ASSET} />}
              />
              <Route
                path="/sldnew"
                name="EnergyEfficiencyReport"
                component={NewSLDViewer}
              />
              <Route
                path="/asset"
                name="Asset"
                component={
                  clientId === '16' // 16 ewii
                    ? AssetDashboardNew
                    : AssetDashboardContainer
                }
              />
              <Route
                path="/exportreports"
                name="EnergyPerformance"
                component={PFCReportContainer}
              />
              <Route
                path="/dashboard"
                name="Monitoring"
                component={Dashboard}
              />
              <Route
                path="/lowcarbon"
                name="LowCarbonReport"
                render={() => (
                  <Analytics appName={constants.core.APPS.LOWCARBON} />
                )}
              />
              <Route path="/sa30i" name="sa30i" component={EmbedComponent} />
              <Route
                path="/unauthorize"
                name="Unauthorize"
                component={Unauthorize}
              />
              <Route
                path="/tree"
                name="HirarchyDashboard"
                component={HirarchyDashboard}
              />
              <Route
                path="/powerbi"
                name="EnergyEfficiencyReport"
                component={PowerBI}
              />
              <Route path="*" component={NotFound} />
            </Switch>
            <HelpboxContainer />
            <div
              dangerouslySetInnerHTML={{ __html: this.state.footerText }}
            ></div>
          </div>
        </div>
        <HelpModal
          show={this.state.showHelp}
          hide={() => this.setState({ showHelp: false })}
        />
      </Suspense>
    );
  }
}

const mapStateToProps = (state) => ({
  loader: state.ActivityIndicatorReducer,
  routechecker: state.HomePageReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      show,
      hide,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Home);
